import React from 'react';

import DataGrid, { Column, FilterRow, Summary, TotalItem } from 'devextreme-react/data-grid';

import { AppCard } from 'components/appComponents';

import { ComingNomenclatureFare } from 'bus/comingNomenclatureMain/types';

type Props = {
  driverPumpSalary: ComingNomenclatureFare | undefined;
};

const ConsumptionNomenclatureSalaryInfo = React.forwardRef<any, Props>(({ driverPumpSalary }, ref) => {
  return (
    <div className="container-dev">
      <AppCard>
        <DataGrid
          dataSource={driverPumpSalary?.data || []}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={ref}
          wordWrapEnabled
        >
          <FilterRow visible={true} />
          <Column dataField="date" caption="Дата" dataType="datetime" sortOrder="asc" width={140} />
          <Column dataField="objectName" caption="Объект" width={300} />
          <Column dataField="requestId" caption="Номер заявки" />
          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="quantity" caption="Кол-во кубов" />
          <Column dataField="pumpInnings" caption="Подача" />
          <Column dataField="pumpQuencher" caption="Гаситель" />
          <Column dataField="pumpMoving" caption="Переезд" />
          <Column dataField="pumpPipes" caption="Трубы" />
          <Column dataField="downtime" caption="Простой" />
          <Column dataField="driverCount" caption="Кол-во водителей" />
          <Column dataField="minimalPrice" caption="Минималка + доплата за куб" />
          <Column dataField="price" caption="Ставка" />
          <Column dataField="toPay" caption="К оплате, руб" />
          <Column dataField="adjustments" caption="Корректировка" />
          <Column dataField="cashFlow" caption="Касса" />

          <Summary>
            <TotalItem column="price" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="toPay" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="adjustments" summaryType="sum" displayFormat="{0}" />
            <TotalItem column="cashFlow" summaryType="sum" displayFormat="{0}" />
          </Summary>
        </DataGrid>
      </AppCard>
    </div>
  );
});

export default ConsumptionNomenclatureSalaryInfo;
